export default __webpack_public_path__ + "static/media/19.b421338b.svg";